import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LockKeyhole, Mail, KeyRound, Loader2, AlertTriangle, LogIn } from "lucide-react";
import Logo from "../components/Logo";

const LOGIN_URL = `${process.env.REACT_APP_BACKEND_URL}/api/auth/login`;

function formatError(detail) {
    if (detail == null) return "Erro ao entrar. Tente novamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && e.msg ? e.msg : String(e))).join(" ");
    return String(detail);
}

export default function Admin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const { data } = await axios.post(LOGIN_URL, { email, password });
            localStorage.setItem("ebh1_admin_token", data.token);
            navigate("/admin/painel");
        } catch (err) {
            setError(formatError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="flex min-h-[70vh] items-center justify-center px-4 py-12"
        >
            <div className="glass-card w-full max-w-sm rounded-2xl p-8">
                <div className="mb-6 flex flex-col items-center gap-3 text-center">
                    <Logo size={52} testid="admin-login-logo" />
                    <div>
                        <h1 className="font-display text-xl font-extrabold text-white">
                            Administração
                        </h1>
                        <p className="font-code text-[10px] uppercase tracking-[0.25em] text-violet-400">
                            EQUIPE STAFF [EBH1]
                        </p>
                    </div>
                </div>
                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-gray-400">
                            <Mail className="h-3.5 w-3.5 text-violet-400" /> E-mail
                        </label>
                        <input
                            data-testid="admin-email-input"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="admin@ebh1.com"
                            required
                            className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-gray-100 outline-none transition-colors placeholder:text-gray-600 focus:border-violet-500/60"
                        />
                    </div>
                    <div>
                        <label className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-gray-400">
                            <KeyRound className="h-3.5 w-3.5 text-violet-400" /> Senha
                        </label>
                        <input
                            data-testid="admin-password-input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                            className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-gray-100 outline-none transition-colors placeholder:text-gray-600 focus:border-violet-500/60"
                        />
                    </div>
                    {error && (
                        <div
                            data-testid="admin-login-error"
                            className="flex items-center gap-2.5 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm font-medium text-red-300"
                        >
                            <AlertTriangle className="h-4 w-4 shrink-0" />
                            {error}
                        </div>
                    )}
                    <button
                        data-testid="admin-login-button"
                        type="submit"
                        disabled={loading}
                        className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-violet-600 to-indigo-600 px-6 py-3.5 text-sm font-bold text-white shadow-lg shadow-violet-900/40 transition-all duration-300 hover:scale-[1.01] disabled:cursor-not-allowed disabled:opacity-60"
                    >
                        {loading ? (
                            <Loader2 className="h-4 w-4 animate-spin" />
                        ) : (
                            <>
                                <LogIn className="h-4 w-4" /> Entrar no Painel
                            </>
                        )}
                    </button>
                </form>
                <p className="mt-5 flex items-center justify-center gap-2 text-center text-[11px] text-gray-600">
                    <LockKeyhole className="h-3.5 w-3.5" /> Área restrita à administração
                </p>
            </div>
        </div>
    );
}
